import i1 from './landscape product shoot/1.jpg'
import i2 from './landscape product shoot/2.jpg'
import i3 from './landscape product shoot/3.jpg'
import i4 from './landscape product shoot/4.jpg'

const productLandscape = [
    i1, i2, i3, i4
]
export default productLandscape;